import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { AlertsProvider } from "./AlertsContext";
import LoginPage from "./LoginPage";
import GlobalView from "./GlobalView";
import FamilyView from "./FamilyView";
import SkuView from "./SkuView";
import AlertingPage from "./AlertingPage";
import MasterDataPage from "./MasterDataPage";
import SkuLtPage from "./SkuLtPage";
import SuppliersPage from "./SuppliersPage";
import QuotationsDemandPage from "./QuotationsDemandPage";
import BookingsPage from "./BookingsPage";
import InventorySnapshotPage from "./InventorySnapshotPage";
import PurchaseOrdersPage from "./PurchaseOrdersPage";
import Forecast from "./Forecast";
import "./App.css";

/** Wraps any route that requires authentication. */
function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

function AppRoutes() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <GlobalView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/family/:familyId"
        element={
          <ProtectedRoute>
            <FamilyView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sku/:skuId"
        element={
          <ProtectedRoute>
            <SkuView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/alerts"
        element={
          <ProtectedRoute>
            <AlertingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/master-data"
        element={
          <ProtectedRoute>
            <MasterDataPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/sku-lt"
        element={
          <ProtectedRoute>
            <SkuLtPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/suppliers"
        element={
          <ProtectedRoute>
            <SuppliersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/quotations-demand"
        element={
          <ProtectedRoute>
            <QuotationsDemandPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/bookings"
        element={
          <ProtectedRoute>
            <BookingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/inventory-snapshot"
        element={
          <ProtectedRoute>
            <InventorySnapshotPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/purchase-orders"
        element={
          <ProtectedRoute>
            <PurchaseOrdersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/forecast"
        element={
          <ProtectedRoute>
            <Forecast />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AlertsProvider>
        <Router>
          <AppRoutes />
        </Router>
      </AlertsProvider>
    </AuthProvider>
  );
}

export default App;
